import ProtectedRoute from '@/components/ProtectedRoute';
import { ALLOWED_TO_ADDITIONAL_DISCHARGES_SUBJECT } from '@/features/additional-discharges';
import { AdditionalDischargesVisualizer } from '@/features/additional-discharges/components/AdditionalDischargesVisualizer';

export const additionalDischargeRoutes = [
  {
    path: '/additional-discharges',
    element: (
      <ProtectedRoute permissions={[{ action: 'read', subject: ALLOWED_TO_ADDITIONAL_DISCHARGES_SUBJECT }]}>
        <AdditionalDischargesVisualizer />
      </ProtectedRoute>
    ),
  },
];
